
angular
  .module('app')
  .factory('RoomGroupCategoryFilters', RoomGroupCategoryFilters);

function RoomGroupCategoryFilters() {
  var roomGroupCategoryFiltersList = [];

  function getRoomGroupCategoryFilters() {
    return roomGroupCategoryFiltersList;
  }

  function setRoomGroupCategoryFilters(roomGroupCategoryFilters) {
    if (angular.isArray(roomGroupCategoryFilters)) {
      roomGroupCategoryFiltersList = roomGroupCategoryFilters;
    }
  }

  return {
    setRoomGroupCategoryFilters: setRoomGroupCategoryFilters,
    getRoomGroupCategoryFilters: getRoomGroupCategoryFilters
  };
}
